import type { RuntimeKeyMeta } from "../types";

export const RUNTIME_KEYS: readonly RuntimeKeyMeta[] = [
  { key: "tick.hz", def: 60, min: 60, max: 60, fixed: true },
  { key: "tick.substeps", def: 4, min: 1, max: 16 },
  { key: "program.opBudget", def: 500, min: 1, max: 2000 },
  { key: "program.opBudgetMax", def: 2000, min: 1, max: 2000 },
  { key: "program.watchdogMs", def: 2000, min: 500, max: 10000 },
  { key: "program.memoryMb", def: 4, min: 1, max: 64 },
  { key: "local.maxFriends", def: 5, min: 0, max: 5 },
  { key: "local.maxGhosts", def: 3, min: 0, max: 3 },
  { key: "input.maxHz", def: 30, min: 1, max: 30 },
  { key: "features.observerShare", def: false, kind: "bool", always: true },
  { key: "share.maxDays", def: 30, min: 1, max: 90, always: true },
  {
    key: "share.otherNames",
    def: "friend",
    kind: "enum",
    options: ["friend", "all"],
    always: true,
  },
];

export const metaOf = (key: string) => RUNTIME_KEYS.find((k) => k.key === key) ?? null;

export const impactKey = (key: string) => `ops.config.impact.${key.replace(/\./g, "_")}`;

/** 고를 수 있는 값(bool · enum) — 그 밖은 null(자유 입력) */
export function choicesOf(m: RuntimeKeyMeta | null): readonly string[] | null {
  if (!m) return null;
  if (m.kind === "bool") return ["true", "false"];
  if (m.kind === "enum") return m.options ?? [];
  return null;
}

/** 범위 칸 문구의 재료 — 고정 · 목록 · 정수 범위 */
export function rangeOf(
  m: RuntimeKeyMeta,
): { fixed: true } | { list: string } | { min: number; max: number } {
  if (m.fixed) return { fixed: true };
  const c = choicesOf(m);
  if (c) return { list: c.join(" | ") };
  return { min: m.min ?? 0, max: m.max ?? 0 };
}

/** 입력 값 검사(클라이언트 1차 — 최종은 서버 422) */
export function checkValue(key: string, raw: string): string | null {
  const m = metaOf(key);
  if (!m) return null;
  const c = choicesOf(m);
  if (c) return c.includes(raw.trim()) ? null : "choice";
  if (!/^-?\d+$/.test(raw.trim())) return "int";
  const n = Number(raw);
  return n < (m.min ?? -Infinity) || n > (m.max ?? Infinity) ? "range" : null;
}
